export default __webpack_public_path__ + "static/media/sunny-stream.963b40eb5864591bfae0ee334ac30df9.jpg";